export default "__VITE_ASSET__BpBeESaf__"